import { render, staticRenderFns } from "./RolesPage.vue?vue&type=template&id=0f3df576&"
import script from "./RolesPage.vue?vue&type=script&lang=js&"
export * from "./RolesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports